var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ReactDOM from "react-dom";
import { AppBar, Box, Button, CssBaseline, Menu, MenuItem, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { Person } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Logo } from "frontend/src/ui/logo";
import { Player } from "frontend/src/features/show-player";
import { useViewer } from "frontend/src/domain/session";
import { logout } from "frontend/src/features/session";
var useStyles = makeStyles({
    box: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    button: {
        textTransform: "initial",
    },
});
var UserMenu = function () {
    var _a;
    var classes = useStyles();
    var user = useViewer().user;
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var onLogoutClick = function () {
        logout();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: classes.button, onClick: handleClick },
            React.createElement(Person, null),
            React.createElement(Box, { ml: 1 },
                React.createElement(Typography, null, (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : React.createElement(Skeleton, { width: 100 })))),
        React.createElement(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "right",
            }, keepMounted: true, onClose: handleClose, getContentAnchorEl: null },
            React.createElement(MenuItem, { onClick: onLogoutClick }, "\u0412\u044B\u0445\u043E\u0434"))));
};
export var EmployeeUserLayout = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "static", color: "inherit" },
            React.createElement(Box, { pl: 3, pr: 3, className: classes.box },
                React.createElement(Logo, { width: 250 }),
                React.createElement(Box, { ml: "auto", display: "flex" },
                    React.createElement(UserMenu, null)))),
        React.createElement(Box, { mt: 3, display: "flex", justifyContent: "center" },
            React.createElement(Box, { width: "90%", maxWidth: 1200 }, children)),
        ReactDOM.createPortal(React.createElement(Player, null), document.body)));
};
